import { createContext, useContext, useState, useEffect } from 'react';
import { collection, query, where, orderBy, onSnapshot, doc, updateDoc } from 'firebase/firestore';
import { db } from '../config/firebase';
import { useAuth } from './AuthContext';
import { DrawNotification } from '../types/draw';

export const NotificationContext = createContext<{
  notifications: DrawNotification[];
  markAsRead: (notificationId: string) => void;
}>({
  notifications: [],
  markAsRead: () => {},
});

export function NotificationProvider({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  const [notifications, setNotifications] = useState<any[]>([]);

  useEffect(() => {
    if (!user?.id) return;

    // Écouter les notifications en temps réel
    const notificationsRef = collection(db, 'notifications');
    const q = query(
      notificationsRef,
      where('userId', '==', user.id),
      where('status', '==', 'pending'),
      orderBy('createdAt', 'desc')
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const newNotifications = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setNotifications(newNotifications);
      console.log('Notifications mises à jour:', newNotifications);
    }, (error) => {
      console.error('Erreur lors de l\'écoute des notifications:', error);
    });

    return () => unsubscribe();
  }, [user?.id]);

  const markAsRead = async (notificationId: string) => {
    if (!user?.id) return;
    
    const notificationRef = doc(db, 'notifications', notificationId);
    await updateDoc(notificationRef, {
      status: 'claimed'
    });
  };

  return (
    <NotificationContext.Provider value={{ notifications, markAsRead }}>
      {children}
    </NotificationContext.Provider>
  );
}

export const useNotifications = () => useContext(NotificationContext); 